/**
 * Hero temporaire - copié de celui du pass
 * Sert à afficher la mosaique avec les stars du moment dont les cours ne sont pas encore sortis
 * A supprimer quand on reviendra sur le Hero classique avec les images qui défilent
 */

import PropTypes from 'prop-types';
import Rating from 'react-rating';
import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { useTranslate } from 'react-polyglot';

import Container from '../../layout/Container';
import WistiaEmbed from '../../video/WistiaEmbed';
import { StarEmpty, StarFull } from '../../icons';
import { nl2br } from '../../../utils/text';
import { translateLocal } from '../../../i18n';
import { withContext } from '../../Context/Context';

import './HeroPass.scss';

const HeroTemp = ({
  context: { data: appContext }, cta, description, medias, title, onVisibilityChange, testimonials, videoId,
}) => {

  const t = useTranslate();

  const titleRef = React.useRef();
  const descriptionRef = React.useRef();

  React.useEffect(() => {
    if (titleRef) {
      titleRef.current.innerHTML = nl2br(title);
    }

    if (descriptionRef) {
      descriptionRef.current.innerHTML = nl2br(description);
    }
  }, []);

  const onHeroVisibilityChange = (isVisible) => {
    if (onVisibilityChange) {
      onVisibilityChange(isVisible);
    }
  };

  return (
    <div className="hero-wrapper pass">
      <Container>
        <div className="hero-cols">
          <div className="content pass">
            <h1 className="title" ref={titleRef} />

            <div className="description" ref={descriptionRef} />

            {cta.description && (
              <p className="cta-description">
                {translateLocal(cta.description)}
              </p>
            )}
            {cta.label && (
              <VisibilitySensor onChange={onHeroVisibilityChange} partialVisibility>
                <div className="cta-actions">
                  <a href={cta.url || '/'} className="button mobile-full-width primary btn-hero-get-pass">{translateLocal(cta.label)}</a>
                </div>
              </VisibilitySensor>
            )}
            {!!appContext?.rating?.average && (
              <div className="rating-wrapper">
                <Rating
                  initialRating={appContext.rating.average}
                  readonly
                  emptySymbol={<StarEmpty className="rating-star" style={{ fontSize: '1.3rem', marginRight: 6 }} />}
                  fullSymbol={<StarFull className="rating-star" style={{ fontSize: '1.3rem', marginRight: 6 }} />}
                />
                <p>({t('common.pass.ratingsAverage', { average: appContext.rating.average, number: appContext.rating.nbRatings })})</p>
              </div>
            )}
          </div>

          <div className="content-video">
            {videoId && (
              <WistiaEmbed
                hashedId={videoId}
                controlsVisibleOnLoad={false}
                shadowed
                // playerColor="#ffffff"
                // continueFromSeconds={10}
              />
            )}
          </div>
        </div>

        <div className="medias-wrapper">
          {medias.map((media, index) => (
            <div key={index} className="media">
              <img src={media.image.src} className="media-img" alt="" />
            </div>
          ))}
        </div>

        <div className="testimonials-wrapper">
          {translateLocal(testimonials).map((testimonial, index) => (
            <div key={index}>
              <div className="text-muted">{testimonial.text}</div>
              <div className="author text-muted">{testimonial.author}</div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

HeroTemp.propTypes = {
  context: PropTypes.object.isRequired,
  cta: PropTypes.shape({
    description: PropTypes.object,
    label: PropTypes.object,
    url: PropTypes.string,
  }),
  description: PropTypes.string.isRequired,
  medias: PropTypes.array.isRequired,
  onVisibilityChange: PropTypes.func,
  title: PropTypes.string.isRequired,
  testimonials: PropTypes.object,
  videoId: PropTypes.string,
};

HeroTemp.defaultProps = {
  cta: {},
  onVisibilityChange: () => {},
  testimonials: {},
  videoId: null,
};

export default withContext(
  HeroTemp,
);
